import * as z from 'zod';

// Types
import { SeoTitleTagZod } from '@/types/SeoTitleTag';
import { ColorThemeEnum } from '@/enum/ColorThemeEnum';

const TitleZod = z.object({
  id: z.number(),
  title: z.string(),
  seoTitleTag: SeoTitleTagZod,
  size: z.enum(['h1', 'h2', 'h3', 'h4']),
  color: z.enum([ColorThemeEnum.WHITE, ColorThemeEnum.BLACK]),
  sizeSpan: z.enum(['m1', 'm2', 'm3']).nullable(),
  colorSpan: z
    .enum([
      ColorThemeEnum.WHITE,
      ColorThemeEnum.ORANGE,
      ColorThemeEnum.YELLOW,
      ColorThemeEnum.PURPLE,
      ColorThemeEnum.LIGHT_PURPLE,
      ColorThemeEnum.GREEN,
    ])
    .nullable(),
});

export { TitleZod };
export type TitleType = z.infer<typeof TitleZod>;
